import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function MicrosoftCallback() {
  const navigate = useNavigate();

  // ✅ Base URL for API — pulled from environment
  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      console.log("✅ Microsoft login successful — token stored");
      localStorage.setItem("token", token);
      localStorage.setItem("isLoggedIn", "true");

      // Redirect to dashboard
      navigate("/dashboard");
    } else {
      console.error("❌ No token received from Microsoft login");

      // Optional: Try refreshing token if backend is reachable
      fetch(`${API_BASE_URL}/api/auth/microsoft/refresh`, {
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.token) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("isLoggedIn", "true");
            navigate("/dashboard");
          } else {
            navigate("/login");
          }
        })
        .catch(() => navigate("/login"));
    }
  }, [navigate, API_BASE_URL]);

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Signing you in with Microsoft...</h2>
        <p>Please wait while we complete your login.</p>
      </div>
    </div>
  );
}
